import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Formatters, OnEventArgs} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import {ConfigService} from '../config.service';


@Component({
    selector: 'app-ticket-menu-config',
    templateUrl: './ticket-menu-config.component.html',
    styleUrls: ['./ticket-menu-config.component.css']
})
export class TicketMenuConfigComponent implements OnInit, OnDestroy {

    newDescription: any;
    displayed = true;
    moduleName: string;
    description: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;
    addUpdate: string[] = ['Add', 'Update'];
    editValue: any;
    color: any;
    sequenceNumber: any;
    managementValue: any;
    //fileToUpload: File = null;
    fileUploadUrl: string;
    uploadButtonName = 'Upload File';
    formdata: any;
    MAX_FILE_UPLOAD = 10;
    hideAttachment: boolean;
    attachment = [];
    attachMsg: string;
    changedName: any;
    submit1: boolean;
    submit2: boolean;

    private fieldName: any;
    fieldValues: any;
    fieldValueSelected: any;
    private fieldValueName: any;

    fieldloader: boolean;
    addloader: boolean;
    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    clients: any;
    fields = [];
    fieldSelected: number;
    clientSelected: number;
    private baseFlag: any;
    private adminAuth: Subscription;
    selectField: any;

    private notifier: NotifierService;
    offset: number;
    hiddenRadio: boolean;
    hiddenRadio1: boolean;
    hideDescName: boolean;
    dataLoaded: boolean;
    colorpicker: boolean;
    sequence: boolean;
    management: boolean;
    file: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    funSelected: any;
    func: any;
    funName: string;
    hiddencolor = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;

    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;
    @ViewChild('content') private content;
    private modalReference1: NgbModalRef;
    imgUrl: any;
    selectedId: any;


    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService, private config: ConfigService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // // console.log(item);
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // item.createdBy = this.messageService.getUserId();
                            // // // console.log('item===' + JSON.stringify(item));
                            // this._rest.updateTicketMenuConfig(item).subscribe((res) => {
                            //     this.respObject = res;
                            //     if (this.respObject.success) {
                            //         // // console.log('data--Done');
                            //         this.notifier.notify('success', 'Updated successfully');
                            //     } else {
                            //         // // console.log('data--Not---Done');
                            //         this.notifier.notify('error', this.respObject.errorMessage);
                            //     }
                            // }, (err) => {
                            //     this.notifier.notify('error', JSON.stringify(err));
                            // });
                        }
                    }
                    break;
                case 'delete':
                    // // console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // // console.log(JSON.stringify(item));
                            this._rest.deleteTicketFunc({user_id: this.messageService.getUserId(), id: item.id}).subscribe((res) => {
                                this.respObject = res;
                                // // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'Ticket Config Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.fieldloader = true;
        this.addloader = true;
        this.paginationType = 'next';
        this.hiddenRadio = false;
        // this.colorpicker = false;
        // this.sequence = false;
        // this.management = false;
        this.newDescription = '';
        this.editValue = '';
        this.displayData = {
            pageName: 'maintain Configuration',
            openModalButton: 'Add Configuration',
            searchModalButton: 'Search',
            breadcrumb: 'Configuration',
            folderName: 'All Configuration',
            tabName: 'Configuration'
        };

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'edit',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.editIcon,
                minWidth: 30,
                maxWidth: 30,
                onCellClick: (e: Event, args: OnEventArgs) => {
                    console.log(args.dataContext);
                    this.selectedId = args.dataContext.id;
                    this.color = args.dataContext.color_code;
                    this.sequenceNumber = args.dataContext.sequence_no;
                    this.fieldSelected = args.dataContext.functionalityId;
                    this.newDescription = args.dataContext.funcDescription;
                    this.managementValue =  args.dataContext.isManagerialview;
                    this.clientSelected = args.dataContext.client_id;
                    if ( Number(this.fieldSelected) === 1) {
                        if((this.color === null) || (this.color === '')){
                            console.log("okkkk");
                            this.colorpicker = false;
                            this.file = true;


                        }else{
                            this.colorpicker = true;
                            this.file  = false;

                        }
                        this.management = true;
                        this.sequence = true;
                        this.hiddenRadio1 = true;
                        this.hiddencolor = true;
                        // this.file = true;
                        this.hideDescName = true;
                    }
                    // else if(Number(this.fieldSelected) === 3){
                    //   this.colorpicker = false;
                    //   this.management = false;
                    //   this.sequence = true;
                    //   this.hiddenRadio1 = false;
                    //   this.file = false;
                    //   this.hiddencolor = false;
                    //   this.hideDescName = false;

                    // }
                    else {
                        this.colorpicker = false;
                        this.management = false;
                        this.sequence = false;
                        this.hiddenRadio1 = false;
                        this.file = false;
                        this.hiddencolor = false;
                        this.hideDescName = false;
                    }
                    this.changedName = args.dataContext.image;
                    this.imgUrl = this.config.UPLOAD_PATH_BASE + 'tcs_icc_poc/asset/' + this.changedName;
                    this.attachMsg = '';
                    this.attachment = [];
                    this.modalReference = this.modalService.open(this.content1, {});
                    this.modalReference.result.then((result) => {
                    }, (reason) => {

                    });
                }
            },

            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'funcDescription', name: 'Function Description', field: 'funcDescription', sortable: true, filterable: true,
            },
            {
                id: 'funcionalityName', name: 'Functionality Name', field: 'funcionalityName', sortable: true, filterable: true
            },
            {
                id: 'clientName', name: 'Client Name', field: 'client_name', sortable: true, filterable: true
            },
            {
                id: 'sequence', name: 'Sequence No', field: 'sequence_no', sortable: true, filterable: true
            },
            {
                id: 'color', name: 'color Code', field: 'color_code', sortable: true, filterable: true, cssClass: 'color{color:red}'
            }


        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }

        // this.messageService.setColumnDefinitions(columnDefinitions);
        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            // // console.log(JSON.stringify(this.respObject.clients));
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {

            }
        }, function (err) {

        });


        this._rest.getAdditionalFunc().subscribe((res1) => {
            this.respObject = res1;
            // // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Additional Field'});
                this.fields = this.respObject.details;
                this.fieldSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onPageLoad() {
        this.formdata = {
            'clientId': this.clientId,
            'createdBy': this.messageService.getUserId(),
            'type': 'type'
        };
        this.getTableData();
    }

    onFieldChange(selectedIndex: any) {
        this.fieldName = this.fields[selectedIndex].name;
        // console.log(this.fieldSelected);
        if (Number(this.fieldSelected) === 1) {
            // this.colorpicker = true;
            this.management = true;
            this.sequence = true;
            this.hiddenRadio1 = true;
            this.hiddencolor = true;
            // this.file = true;
            // this.hideDescName = true;
        } else {
            this.colorpicker = false;
            this.management = false;
            this.sequence = false;
            this.hiddenRadio1 = false;
            this.file = false;
            this.hiddencolor = false;
            // this.hideDescName = false;
        }
        this._rest.getAdditionalFuncTicketTypeWise(this.clientId, this.fieldSelected).subscribe((res1) => {
            this.respObject = res1;
            // console.log(this.respObject);
            // // console.log(JSON.stringify(res1));
            if (this.respObject.success) {
                this.hiddenRadio = true;
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Field Value'});
                this.fieldValues = this.respObject.details;
                // // console.log(this.fieldValues);
                this.selectField = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    addColorPicker() {
        this.colorpicker = true;
        this.file = false;
    }

    addImage() {
        this.colorpicker = false;
        this.file = true;
    }

    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.moduleName = '';
            this.description = '';
            this.color = '';
            this.sequenceNumber = '';
            this.attachMsg = '';
            this.attachment = [];
            this.newDescription = '';
            this.managementValue = '';
            this.changedName = '';
            this.fieldSelected = 0;
            // this.formdata = '';
            this.clientSelected = 0;
            this.hiddenRadio = false;
            this.colorpicker = false;
            this.file = false;
            // this.notifier.notify('success', 'Module added successfully');
            this.modalReference1 = this.modalService.open(this.content , ({size: 'sm'}));
            this.modalReference1.result.then((result) => {
            }, (reason) => {

            });

            // this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            // }, (reason) => {

            // });
        }

    }


    searchModal() {

        this.funSelected = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });

    }

    getDetails() {
        for (let i = 0; i < this.func.length; i++) {
            if (this.func[i].funcDescription === this.funSelected) {
                this.funName = this.func[i].funcionalityName;
            }
        }
    }

    search() {
        this._rest.searchAllMenuConfiguration(this.funSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.func = this.respObject.details;
                this.messageService.setTotalData(this.func.length);
                this.messageService.setGridData(this.func);
                this.searchModalReference.close();


            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        const data = {
            'client_id': this.clientSelected,
            'func_id': this.fieldSelected,
            'func_desc': this.newDescription,
            'createdBy': this.messageService.getUserId(),
        };
        if (!this.messageService.isBlankField(data)) {
            data['color'] = this.color;
            data['image'] = this.changedName;
            data['sequence'] = this.sequenceNumber;
            data['managementValue'] = this.managementValue;

            console.log('data=======' + JSON.stringify(data));

            this._rest.insertTicketFunc(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // this.totalData = this.totalData + 1;
                    // this.messageService.setTotalData(this.totalData);
                    this.notifier.notify('success', 'Ticket configuration add successfully');
                    this.modalReference1.close();
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.editValue = '';
                    this.selectField = 0;
                    this.fieldSelected = 0;
                    this.clientSelected = 0;
                    this.fieldloader = true;
                    this.addloader = true;
                    this.color = '';
                    this.sequenceNumber = '';
                    this.attachMsg = '';
                    this.attachment = [];
                    this.newDescription = '';
                    this.managementValue = '';
                    this.changedName = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    update() {
        const data = {
            'client_id': this.clientSelected,
            'func_id': this.fieldSelected,
            'id': this.selectedId,
            'func_desc': this.newDescription,
            'createdBy': this.messageService.getUserId(),
        };
        if (!this.messageService.isBlankField(data)) {
            data['color'] = this.color;
            data['image'] = this.changedName;
            data['sequence'] = this.sequenceNumber;
            data['managementValue'] = this.managementValue;

            // console.log('data=======' + JSON.stringify(data));

            this._rest.updateTicketMenuConfig(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // this.totalData = this.totalData + 1;
                    // this.messageService.setTotalData(this.totalData);
                    this.notifier.notify('success', 'Ticket configuration Update successfully');

                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    // this.editValue = '';
                    // this.selectField = 0;
                    // this.fieldSelected = 0;
                    // this.clientSelected = 0;
                    // this.fieldloader = true;
                    // this.addloader = true;
                    // this.color = '';
                    // this.sequenceNumber = '';
                    // this.attachMsg = '';
                    // this.attachment = [];
                    // this.newDescription = '';
                    // this.managementValue = '';
                    // this.changedName = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }

    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }

    }

    submitUpdate() {
        const data = {
            'client_id': this.clientSelected,
            'func_id': this.fieldSelected,
            'func_desc': this.editValue,
            'func_desc_id': this.selectField,
        };
        if (!this.messageService.isBlankField(data)) {
            data['color'] = this.color;
            data['image'] = this.changedName;
            data['sequence'] = this.sequenceNumber;
            data['managementValue'] = this.managementValue;
            console.log('data=======' + JSON.stringify(data));

            // console.log( typeof this.sequenceNumber);


            this._rest.updateTicketFunc(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {

                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.notifier.notify('success', 'Ticket configuration add successfully');

                    this.editValue = '';
                    this.selectField = 0;
                    this.fieldSelected = 0;
                    this.clientSelected = 0;
                    // this.hiddenRadio = false;
                    this.fieldloader = true;
                    this.isError = false;
                    this.color = '';
                    this.sequenceNumber = '';
                    this.attachMsg = '';
                    this.attachment = [];
                    this.newDescription = '';
                    this.managementValue = '';
                    this.changedName = '';
                    this.colorpicker = false;
                    this.file = false;

                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    adddescription() {
        this.addloader = false;
        this.fieldloader = true;
        this.hideDescName = true;
        this.attachMsg = '';
        this.attachment = [];
        this.sequenceNumber = '';

    }

    changedescription() {
        this.fieldloader = false;
        this.addloader = true;
        this.attachMsg = '';
        this.attachment = [];
        this.changedName = '';
        this.sequenceNumber = '';
    }

    valueFunc(temp) {
        // console.log(this.fieldValues[temp].name);
        this.editValue = this.fieldValues[temp].name;
        this.color = this.fieldValues[temp].color_code;

        if (this.fieldValues[temp].seq === '') {
            this.sequenceNumber = '';

        } else {
            this.sequenceNumber = this.fieldValues[temp].seq;

        }
        this.managementValue = this.fieldValues[temp].isManagerialview;


        console.log('seq' + this.sequenceNumber);

    }

    onButtonChange(value) {
        // console.log(value);
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getTicketFunc(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onFileError(msg: string) {
        this.notifier.notify('error', msg);
    }

    onFileComplete(data: any) {
        this.changedName = data.changedName;
        if (data.success) {
            this.hideAttachment = false;
            if (this.attachment.length > this.MAX_FILE_UPLOAD - 1) {
                this.attachMsg = 'More than ' + this.MAX_FILE_UPLOAD + ' files is not permitted';
            } else {
                this.attachment.push({originalName: data.fileName, fileName: data.changedName});
                if (this.attachment.length > 1) {
                    this.attachMsg = this.attachment.length + ' files uploaded successfully';
                } else {
                    this.attachMsg = this.attachment.length + ' file uploaded successfully';
                }
            }
        }
    }

    onUpload(data: any) {
        this.dataLoaded = data.loader;
    }

    clientIdSpecific(e: any) {
        this.formdata = {clientId: this.clientSelected};
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
